import { ArrowDownIcon, ArrowUpIcon, EyeIcon, EyeSlashIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline'
import cloneDeep from 'clone-deep'

import { Input2 } from '../Input2/Input2'
import { ISelectOption } from './types'

export const SelectOptionInputs = ({
  title = 'Select Options',
  value = [],
  onChange,
}: {
  title?: string
  value: ISelectOption[]
  onChange: Function
}) => {
  const onAddOption = () => {
    const newValue = cloneDeep(value || [])
    newValue.push({
      key: `${Date.now()}`,
      title: '',
      visible: true,
      isCustom: true,
    })
    onChange(newValue)
  }

  const onChangeControlOption = (
    idx: number,
    newValue: { [P in keyof ISelectOption]?: NonNullable<ISelectOption[P]> } | null,
  ) => {
    const newValues = cloneDeep(value)

    if (!newValue) newValues.splice(idx, 1)
    else {
      newValues[idx] = {
        ...newValues[idx],
        ...newValue,
      }
    }

    onChange(newValues)
  }

  const onChangeControlOptionOrder = (idx: number, dir: 1 | -1) => {
    const newConfigs = cloneDeep(value)

    const newIdx = idx + dir
    if (newIdx < 0 || newIdx >= newConfigs.length) return
    else {
      let temp: ISelectOption = newConfigs[idx]
      newConfigs[idx] = newConfigs[newIdx]
      newConfigs[newIdx] = temp
    }

    onChange(newConfigs)
  }

  return (
    <div className="grid gap-2">
      <div className="flex justify-between">
        <p className="font-bold text-sm">{title}</p>
        <span className="btn-icon" onClick={onAddOption}>
          <PlusIcon className="w-4 h-4" />
        </span>
      </div>
      {value.map((opt, idx) => {
        const { key, title, visible, isCustom } = opt
        const isVisible = !!visible || visible === undefined
        const Icon = isVisible ? EyeIcon : EyeSlashIcon

        return (
          <Input2
            title={`${idx + 1}. ${isCustom ? '' : key}`}
            value={title}
            key={`Option-${idx}-${key}`}
            placeholder={title}
            className={isVisible ? 'opacity-100' : 'opacity-30'}
            onChange={(value: string) => onChangeControlOption(idx, { title: value })}
            additionalElements={() => (
              <div className="flex gap-2">
                <Icon
                  className="w-4 h-4 cursor-pointer"
                  onClick={() => onChangeControlOption(idx, { visible: !isVisible })}
                />
                {isCustom && (
                  <TrashIcon
                    className="w-4 h-4 cursor-pointer text-red-500"
                    onClick={() => onChangeControlOption(idx, null)}
                  />
                )}
                <ArrowUpIcon
                  className="w-4 h-4 cursor-pointer text-shade-blue"
                  onClick={() => onChangeControlOptionOrder(idx, -1)}
                />
                <ArrowDownIcon
                  className="w-4 h-4 cursor-pointer text-shade-blue"
                  onClick={() => onChangeControlOptionOrder(idx, 1)}
                />
              </div>
            )}
          />
        )
      })}
    </div>
  )
}
